import React from "react";
import { Sparkles } from "lucide-react";
import { motion } from "framer-motion";
import { Box, Typography, Button } from "@mui/material";

const MaintenancePage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #F3F4F6 30%, #9CA3AF 90%)", // Soft gradient background
        padding: { xs: 2, sm: 4 },
        overflow: "hidden",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        sx={{
          maxWidth: "lg",
          borderRadius: "20px", // Rounded corners
          background: "#FFFFFF",
          padding: "2.5rem",
          boxShadow: "0 8px 16px rgba(0, 0, 0, 0.15)",
          border: "1px solid #E5E7EB",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          position: "relative",
          animation: "floating 3s ease-in-out infinite", // Add floating animation
        }}
      >
        {/* Interactive Sparkles */}
        <motion.div
          animate={{
            x: [0, 20, 0],
            y: [0, 20, 0],
            rotate: [0, 10, -10],
          }}
          transition={{
            repeat: Infinity,
            duration: 2,
            ease: "easeInOut",
          }}
          style={{ position: "absolute", top: "-30px", left: "10px", zIndex: 1 }}
        >
          <Sparkles className="text-indigo-500 h-12 w-12 animate-pulse" />
        </motion.div>

        <Typography
          variant="h3"
          color="primary"
          fontWeight="bold"
          sx={{
            marginBottom: "1.5rem",
            fontSize: { xs: "2rem", sm: "3rem" },
            textTransform: "uppercase",
            letterSpacing: "1px",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
          }}
        >
          Under Maintenance
        </Typography>

        <Typography
          sx={{
            marginTop: 2,
            color: "#4B5563",
            fontSize: "1.25rem",
            fontWeight: "500",
            maxWidth: "600px",
          }}
        >
          We're working hard to improve your experience. The section you're trying to access is temporarily down for scheduled maintenance.
          <br />
          Please check back soon!
        </Typography>

        {/* Call to Action */}
        <Box
          sx={{
            marginTop: 4,
            borderTop: "1px solid rgba(0, 0, 0, 0.1)",
            paddingTop: 3,
            textAlign: "center",
            fontSize: "1rem",
            color: "#6B7280",
          }}
        >
          <Typography>
            If the issue persists, reach out to us at{" "}
            <a
              href="mailto:support@liaplus.com"
              style={{
                color: "#6366F1",
                textDecoration: "underline",
                fontWeight: "500",
              }}
            >
              support@liaplus.com
            </a>
            .
          </Typography>
        </Box>

        {/* Back to Home Button */}
        <Box sx={{ marginTop: 4 }}>
          <Button
            variant="contained"
            color="primary"
            href="/"
            sx={{
              py: 1.5,
              px: 4,
              borderRadius: 2,
              fontWeight: "600",
              fontSize: "1rem",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
              "&:hover": {
                bgcolor: "#4C51BF",
              },
            }}
          >
            Back to Home
          </Button>
        </Box>

        {/* Footer */}
        <Box sx={{ marginTop: 6, textAlign: "center", fontSize: "0.75rem", color: "#A5A5B2" }}>
          <Typography>&copy; {new Date().getFullYear()} LIA+. All rights reserved.</Typography>
        </Box>
      </motion.div>
    </Box>
  );
};

export default MaintenancePage;
